<template>
    <button @click="logout">Logout</button>
  </template>

  <script>
  import axios from 'axios';

  export default {
    name: 'Logout',
    methods: {
      logout() {
        const token = localStorage.getItem('token');
        if (!token) {
          this.handleLogout();
          return;
        }

        axios.post('/api/auth/logout', {}, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
          this.handleLogout();
        })
        .catch(error => {
          console.error('Error logging out:', error);
          this.handleLogout();
        });
      },
      handleLogout() {
        localStorage.removeItem('token');
        this.$router.push('/login');
      }
    }
  };
  </script>

  <style scoped>
  /* Add styles for your logout component here */
  </style>
